import { HttpClient, HttpHeaders } from "@angular/common/http";
import { IdentityModel } from "src/app/models/identity.model";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
// import { environment } from "src/environments/environment";
import { CiCdConfigService } from "src/cicd/ci-cd-config.service";

@Injectable({
  providedIn: "root"
})
export class AuthService {
  private urlApi: string;
  private app: string ='';
  public headers: HttpHeaders;
  public userData: IdentityModel = new IdentityModel();
  public userToken: any;
  public visible: boolean;
  public userId: any = { documento: '', tipo_documento: '' };

  constructor(private readonly http: HttpClient,
    private readonly ciCd: CiCdConfigService) {
    // this.urlApi = environment.urlApi; // PREJENKINS
    this.ciCdInit();
    this.visible = false;
    this.readToken();
  }

  ciCdInit() {
    this.ciCd.loadConfigurations().subscribe(({ apis }: any) => {
      const { urlApi, app } = apis;
      this.urlApi = urlApi;
      this.app = app;
    });
  }

  // Login
  login(user: any) {
    this.isAutenticated();
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    user.contrasena = user.contrasena;
    user.app_covinoc = this.app;
    const options = {
      params: null,
      headers
    };

    return this.http.post(`${this.urlApi}/inicio_sesion`, user, options).pipe(
      map((resp: any) => {
        // Expira token
        const expiraToken = new Date(resp.expira);
        localStorage.setItem("expiresCRE", expiraToken.getTime().toString());
        this.saveToken(resp["TOKEN"]);
        return resp;
      })
    );
  }

  // Password
  updatePass(data: any) {
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json");
    headers = headers.set("token", localStorage.getItem("tokenCVE"));
    const options = {
      params: null,
      headers
    };
    return this.http.post(
      `${this.urlApi}/pr_actualiza_contrasena_usuarios`,
      data,
      options
    );
  }

  // Guardar Token
  private saveToken(token: string) {
    this.userToken = token;
    localStorage.setItem("tokenCVE", token);
  }

  // Leer Token

  readToken() {
    if (localStorage.getItem("tokenCVE")) {
      this.userToken = localStorage.getItem("tokenCVE");
    } else {
      this.userToken = "";
    }

    return this.userToken;
  }

  // Logout

  validateForgotPassword(user: string, app_covinoc: string) {
    this.headers = new HttpHeaders();
    this.headers = this.headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );

    const headers = this.headers;
    const body = { usuario: user, app_covinoc };
    const options = { params: body, headers };

    return this.http.post(
      `${this.urlApi}/solicitar_cambio_contrasena`,
      body,
      options
    );
  }

  forgotPassword(token: string, newPass: string) {
    this.headers = new HttpHeaders();
    this.headers = this.headers.set("Content-Type", "application/json");

    const headers = this.headers;
    const body = { token_cambio: token, nueva_contrasena: newPass };
    const options = { params: null, headers };

    return this.http.post(`${this.urlApi}/cambiar_contrasena`, body, options);
  }

  logout() {
    localStorage.removeItem("tokenCVE");
  }

  // Get identity

  getIdentity() {
    return (this.userData = JSON.parse(localStorage.getItem("identityCVE")));
  }

  getDocument() {
    this.getIdentity();
    this.userId.documento = this.userData.v_documento;
    this.userId.tipo_documento = this.userData.v_tipo_documento;
    return this.userId;
  }



  // Validar Autenticación
  isAutenticated(): boolean {
    const today = new Date().getTime();
    const expira = Number(localStorage.getItem("expiresCRE"));
    if (
      localStorage.getItem("tokenCVE") === undefined ||
      localStorage.getItem("tokenCVE") === null ||
      expira < today
    ) {
      return false;
    } else {
      return this.userToken;
    }
  }

  getWebContracts(data: any) {
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/x-www-form-urlencoded");
    headers = headers.set("token", localStorage.getItem("tokenCVE"));

    const options = { params: data, headers };
    return this.http.get(`${this.urlApi}/pr_consulta_contratos_web`, options);
  }

  hide() {
    this.visible = false;
  }
  show() {
    this.visible = true;
  }
  toggle() {
    this.visible = !this.visible;
  }
}
